import { GroupedOffers } from '../utils/groupOffers';
import type { FilterTypes } from './initialFilters';

export type NavConfigsOutpout = {
  elementId: string;
  navId: string;
  label: string;
  disabled: boolean;
}[];

export const getNavConfigs = (
  isAnyFilterSelected: boolean,
  selectedFilters: FilterTypes,
  groupedModels: { [key: string]: string[] },
  sortedOffers: GroupedOffers,
): NavConfigsOutpout => {
  return [
    // This nav item is invisible always
    // {
    //   elementId: 'default',
    //   navId: 'nav-default',
    //   label: 'default',
    //   disabled: false,
    // },
    {
      elementId: 'featured',
      navId: 'nav-featured',
      label: 'Featured',
      disabled: isAnyFilterSelected,
    },
    {
      elementId: 'etron-model',
      navId: 'nav-etron-model',
      label: 'e-tron',
      disabled:
        // Two scenarios can disable a sticky nav options
        // 1 - There is a filter selected and that filter is a model family filter and
        // selected model family filters don't include one of the model family's of that model group
        // 2 - There is a filter selected and no offers belongs to a model family of that modelGroup
        (isAnyFilterSelected &&
          !!selectedFilters.modelFamily.length &&
          !groupedModels.etron.some((modelFamily) =>
            selectedFilters.modelFamily.includes(modelFamily),
          )) ||
        (isAnyFilterSelected && !Object.keys(sortedOffers.etron).length),
    },
    {
      elementId: 'q/sq-model',
      navId: 'nav-qsq-model',
      label: 'Q/SQ',
      disabled:
        (isAnyFilterSelected &&
          !!selectedFilters.modelFamily.length &&
          !groupedModels['q/sq'].some((modelFamily) =>
            selectedFilters.modelFamily.includes(modelFamily),
          )) ||
        (isAnyFilterSelected && !Object.keys(sortedOffers['q/sq']).length),
    },
    {
      elementId: 'a/s-model',
      navId: 'nav-as-model',
      label: 'A/S',
      disabled:
        (isAnyFilterSelected &&
          !!selectedFilters.modelFamily.length &&
          !groupedModels['a/s'].some((modelFamily) =>
            selectedFilters.modelFamily.includes(modelFamily),
          )) ||
        (isAnyFilterSelected && !Object.keys(sortedOffers['a/s']).length),
    },
    // {
    //   elementId: 'r/rs-model',
    //   navId: 'nav-rrs-model',
    //   label: 'R/RS',
    //   disabled:
    //     (isAnyFilterSelected &&
    //       !!selectedFilters.modelFamily.length &&
    //       !groupedModels['r/rs'].some((modelFamily) =>
    //         selectedFilters.modelFamily.includes(modelFamily),
    //       )) ||
    //     (isAnyFilterSelected && !Object.keys(sortedOffers['r/rs']).length),
    // },
  ];
};

// make it dynamic later - CHANGE
export const StickyNavHeight = (isLaptop: boolean) => {
  if (isLaptop)
    return {
      numValue: 116,
      strValue: '116px',
    };
  return {
    numValue: 95,
    strValue: '95px',
  };
};
